import $ from 'jquery';
import { AppManager } from '@common';

let animating = false;
const animateShowBar = () => {
  const listElement = $('#lang-select .lang-list');
  animating = true;
  listElement.animate({
    height: 'toggle'
  }, {
    duration: 10,
    complete: () => {
      listElement.animate({ opacity: 1 }, {
        complete: () => animating = false
      });
    }
  });
};

const animateHideBar = () => {
  const listElement = $('#lang-select .lang-list');
  animating = true;
  listElement.animate({
    opacity: 0
  }, {
    duration: 10,
    complete: () => {
      listElement.animate({ height: 'toggle' }, {
        complete: () => animating = false
      });
    }
  });
};

export function addSelectElement() {
  const tag = `
<div id="lang-select">
  <div class="wrapper">
    <header class="toggle-open">
      <div class="current-view"></div>
      <span class="divider"></span>
      <div class="bar-title">
        <p class="text-s">Language</p>
      </div>
    </header>
    <ul class="lang-list">
      <li><button class="lang" data-lang="ja">日本語</button></li>
      <li><button class="lang" data-lang="en">ENGLISH</button></li>
      <li><button class="lang" data-lang="ko">한국어</button></li>
      <li><button class="lang" data-lang="zh-Hans">中文（簡体）</button></li>
      <li><button class="lang" data-lang="zh-Hant">中文（繁体）</button></li>
    </ul>
  </div>
</div>
  `;
  $('body').prepend(tag.trim());

  const listElement = $('#lang-select .lang-list');
  listElement.hide();
  listElement.css({ opacity: 0 });
  $('#lang-select .toggle-open').on('click', () => {
    if (listElement.is(':hidden')) {
      animateShowBar();
    } else {
      animateHideBar();
    }
  });

  $('#lang-select .lang').on('click', event => {
    if (animating) return false;
    const lang = $(event.target).data('lang');
    if (AppManager.onLanguageSelected(lang)) {
      this.determineLanguage(lang);
      animateHideBar();
    }
  });

  $('#lang-select').hide();
};


export function detectLanguage() {
  const uaLang = (window.navigator.languages && window.navigator.languages[0]) ||
    window.navigator.language ||
    window.navigator.userLanguage ||
    window.navigator.browserLanguage;
  // クライアント側で受け付けている言語リストを取得
  const uaLangs = window.navigator.languages || [
    window.navigator.language ||
    window.navigator.userLanguage ||
    window.navigator.browserLanguage
  ];
  let lang;
  if (uaLang === 'ja') {
    lang = 'ja';
  } else if (uaLang.slice(0, 2) === 'zh') {
    if (uaLang.indexOf('Hant') > 0) {
      lang = 'zh-Hant';
    } else {
      lang = 'zh-Hans';
    }
  } else {
    lang = 'en';
  }
  return lang;
}


export function determineLanguage(lang) {
  const selectedButton = $(`#lang-select .lang[data-lang=${lang}]`);
  const val = selectedButton.html();
  $('#lang-select .current-view').html(val);

  // switch current
  $('#lang-select .lang-list li').removeClass('current');
  selectedButton.parent().addClass('current');

  $('body').removeClass('lang-ja lang-zh-Hant lang-zh-Hans lang-en');
  $('body').addClass(`lang-${lang}`);
}


export function show() {
  $('#lang-select').show();
}